import React from 'react';
import mixpanelAnalytics from './MixpanelAnalytics';

const resolveCallable = callableParam => {
  if (typeof callableParam === 'function') {
    return callableParam();
  } else {
    return callableParam;
  }
};

const trackEventOnMount = (
  eventName,
  { eventProps = {}, userProps } = {}
) => WrappedComponent => {
  return class WrapperComponent extends React.Component {
    componentDidMount() {
      mixpanelAnalytics.trackEvent(eventName, resolveCallable(eventProps));
      if (userProps) {
        mixpanelAnalytics.setUserProperties(resolveCallable(userProps));
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default trackEventOnMount;
